/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchListParams,
  GetPouchListResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Pouch list of last status(version V0000000000) records for a branch
 * @summary Get Pouch list of latest status for a branch
 */
export const getPouchList = (params?: GetPouchListParams, signal?: AbortSignal) => {
  return customInstance<GetPouchListResponseResponse>({
    url: `/bm-pouch-management/v1/pouch/list`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetPouchListQueryKey = (params?: GetPouchListParams) => {
  return [`/bm-pouch-management/v1/pouch/list`, ...(params ? [params] : [])] as const;
};

export const getGetPouchListQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouchList>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  params?: GetPouchListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchList>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouchList>>> = ({ signal }) =>
    getPouchList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPouchList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPouchListQueryResult = NonNullable<Awaited<ReturnType<typeof getPouchList>>>;
export type GetPouchListQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Get Pouch list of latest status for a branch
 */
export const useGetPouchList = <
  TData = Awaited<ReturnType<typeof getPouchList>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  params?: GetPouchListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchList>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
